export default __webpack_public_path__ + "static/media/dessert03.233818fc.png";